<template>
  <router-view />
</template>

<script>
export default {
  name: 'BlankParentNode'
}
</script>
